import { Ticket } from "../../models/Ticket";
import Badge from "../miscellaneous/Badge";

export interface TicketEntryProps {
  ticket: Ticket;
  drawTicket?: Ticket;
  onTooltip?: (number?: bigint, star?: bigint) => string;
}

export default function TicketEntry(props: TicketEntryProps) {
  return (
    <div className="flex flex-row items-center animate-in spin-in-12">
      {props.ticket.mainNumbers
        .map((mainNumber) => (
          <div
            key={mainNumber}
            data-tooltip-id="default-tooltip"
            data-tooltip-class-name="z-20"
            data-tooltip-content={
              props.onTooltip ? props.onTooltip(mainNumber) : ""
            }
          >
            <Badge
              key={mainNumber}
              selected={false}
              onSelect={undefined}
              isStar={false}
              isCorrect={props.drawTicket?.mainNumbers.includes(mainNumber)}
            >
              {Number(mainNumber)}
            </Badge>
          </div>
        ))
        .sort((a, b) => a.props.value - b.props.value)}
      {props.ticket.luckyStars.map((luckyStar) => (
        <div
          key={luckyStar}
          data-tooltip-id="default-tooltip"
          data-tooltip-class-name="z-20"
          data-tooltip-content={
            props.onTooltip ? props.onTooltip(undefined, luckyStar) : ""
          }
        >
          <Badge
            key={luckyStar}
            selected={false}
            onSelect={undefined}
            isStar={true}
            isCorrect={props.drawTicket?.luckyStars.includes(luckyStar)}
          >
            {Number(luckyStar)}
          </Badge>
        </div>
      ))}
    </div>
  );
}
